class Cache {
    constructor() {
        this.data = {};
    }

    // create new cache record
    init(cacheId) {
        if (!this.data[cacheId]) {
            this.data[cacheId] = {};
        }
    }

    save(cacheId, key, data) {
        if (this.data[cacheId]) {
            this.data[cacheId][key] = data;
        }
    }

    has(cacheId, key) {
        return this.data[cacheId][key] ?? false;
    }

    delete() {}

    get(cacheId, key) {
        return this.data[cacheId][key];
    }
}

export default new Cache();
